import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import { Card, Container, Row, Col, Image, Modal } from "react-bootstrap";
import ReactHtmlParser from "react-html-parser";
import Api from "../Api";
import Circuit from "../Circuit";
import Letter from "../Letter/Letter";
import classes from "../teams.module.css";
import "../teams.css";
// import Palette from "../palette";
// import Palette from "react-palette";
// import { usePalette } from "react-palette";

class teams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: null,
      sections: {
        widgets: [],
      },
      dummy: [
        {
          id: 1,
          name: "Chairman Image",
          assets: require("../assets/default-image.svg"),
        },
        {
          id: 2,
          name: "Article",
          articles: [
            {
              name: "Article1",
              title: "What is Lorem Ipsum?",
              content:
                "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
              assets: require("../assets/default-image.svg"),
            },
          ],
        },
        {
          id: 3,
          name: "Title",
          content: "Lorem Ipsum Lorem Ipsum?",
        },
        {
          id: 4,
          name: "Organization Chart",
          assets: require("../assets/default-image.svg"),
        },
      ],
      isLoaded: false,
      isApiLoaded: false,
      isShowing: false,
      isClose: false,
      closeModal: false,
      isLoaded: false,
      detailLoaded: false,
      detailChart: false,
    };
    this.getSectionDetail = this.getSectionDetail.bind(this);
  }

  componentDidMount() {
    this.getSectionDetail();
  }

  toggleShowing = () => {
    this.setState({
      isShowing: true,
    });
  };

  isClose = () => {
    this.setState({
      isShowing: false,
    });
  };

  getHtmlParagraph(str) {
    if (str !== "") {
      return str.replace(/<\/?p>/gi, " ").replace(/<p>/gi, " ");
    }
  }

  toggleShowing = (param) => {
    if (param === "chart") {
      this.setState({ detailChart: true });
    } else {
      this.setState({ detailLoaded: true });
    }
  };
  toggleHiding = (param) => {
    if (param === "chart") {
      this.setState({ detailChart: false });
    } else {
      this.setState({ detailLoaded: false });
    }
  };

  getSectionDetail() {
    const apiData = new Api();
    this.setState(
      {
        sections: [],
      },
      () =>
        apiData
          .getSectionDetail()
          .then((result) => {
            this.setState({
              isApiLoaded: true,
            });
            const sections = result.data;
            const widget = [];
            result.data.widgets.forEach((item) => {
              widget.push({
                id: item.id,
                index: item.index,
                category: item.category,
                name: item.name,
                sections: item,
              });
            });
            sections.page = widget;
            this.setState({
              sections: widget,
              isLoaded: true,
            });
          })
          .catch((error) => {
            this.setState({
              isApiLoaded: true,
            });
          })
    );
  }

  render() {
    const CloseButton = () => <button>Close modal</button>;
    // const { data, loading, error } = usePalette(require("../assets/1.jpg"));

    const { sections, dummy } = this.state;
    let title,
      contents,
      images,
      name,
      titleP,
      imageChart,
      contentArticle,
      contentLetter,
      articleBoxes,
      dummyArticle,
      dummyChairman,
      dummyOrChart,
      readText,
      dummyTitle = null;

    dummyChairman = (
      <img className={classes.img_first} src={dummy[0].assets} alt="" />
    );
    dummyArticle = dummy[1].articles.map((s) => {
      titleP = <h4>{s.title}</h4>;
      let isImage = s.assets ? (
        <img className={classes.image} src={s.assets} alt="" />
      ) : (
        <img
          className={classes.imageDefault}
          src={require("../assets/default-image.svg")}
          alt=""
        />
      );
      return (
        <Row>
          <div className={classes.row_first}>
            <div className={classes.col_first}>
              <img className={classes.img_first} src={s.assets} alt="" />
            </div>
            <div className={classes.col_second}>
              {titleP}
              <br />
              <p>{s.content}</p>
              <br />
              <p onClick={this.toggleShowing}>Read more</p>
            </div>
          </div>
        </Row>
      );
    });
    dummyTitle = (
      <p className={classes.card_text_row_1_col_2}>{dummy[2].content}</p>
    );
    dummyOrChart = (
      <Card.Img className={classes.image_zoom} src={dummy[3].assets} />
    );

    if (this.state.isLoaded) {
      let count = 0;
      let titleSection = null;
      sections.forEach((item) => {
        count = count + 1;

        if (count === 1 && item.index === 1 && item.category === "Media") {
          item.sections.widget_contents.forEach((s) => {
            if (s.file !== "") {
              images = (
                <img className={classes.img_first} src={s.file} alt="" />
              );
            } else {
              images = dummyChairman;
            }
          });
        } else if (
          count === 1 &&
          item.index === 1 &&
          item.category !== "Media"
        ) {
          images = dummyChairman;
        }
        if (count === 2 && item.index === 2 && item.category === "Text") {
          readText = item.sections.widget_contents[0]
            ? item.sections.widget_contents[0].content
            : "Click More";
        } else if (
          count === 2 &&
          item.index === 2 &&
          item.category !== "Text"
        ) {
          readText = "Click";
        }

        if (count === 3 && item.index === 3 && item.category === "Article") {
          contentArticle = item.sections.widget_contents.map((s) => {
            // console.log(">> " + s.title + " <<");
            titleP = <h2>{s.title}</h2>;
            let isImage = s.assets[0] ? (
              <img className={classes.image} src={s.assets[0].file} alt="" />
            ) : (
              <img
                className={classes.imageDefault}
                src={require("../assets/default-image.svg")}
                alt=""
              />
            );
            // let contents = '"' + this.getHtmlParagraph(s.content) + '"';
            let contents = ReactHtmlParser(this.getHtmlParagraph(s.content));
            return (
              <div className={classes.col_second}>
                {/* {titleP} */}
                {/* <p>{ReactHtmlParser(contents)}</p> */}
                {/* <div className={classes.blockquote}> */}
                {titleP}
                <h4>{contents}</h4>
                {/* </div> */}
                <div className={classes.boxLinks2}>
                  <div className={classes.outerCircle2}>
                    <div className={classes.innerCircle2}></div>
                  </div>

                  <p className={classes.readMore} onClick={this.toggleShowing}>
                    {readText}
                  </p>
                </div>
              </div>
            );
          });
        } else if (
          count === 3 &&
          item.index === 3 &&
          item.category !== "Article"
        ) {
          contentArticle = dummyArticle;
        }

        if (count === 4 && item.index === 4 && item.category === "Text") {
          let url = item.sections.url ? item.sections.url : "";
          item.sections.widget_contents.map((ele) => {
            if (ele.content !== "") {
              name = (
                <Link to={url}>
                  <Card.Text
                    onClick={() => this.toggleShowing("chart")}
                    className={[classes.card_text_row_1_col_2].join(" ")}
                  >
                    {ele.content}
                  </Card.Text>
                  <p
                    onClick={() => this.toggleShowing("chart")}
                    className={classes.cardTextView}
                  >
                    Click to view
                  </p>
                </Link>
              );
            } else {
              name = (
                <Link to={url}>
                  <Card.Text
                    onClick={() => this.toggleShowing("chart")}
                    className={[classes.card_text_row_1_col_2].join(" ")}
                  >
                    {dummyTitle}
                  </Card.Text>
                  <p
                    onClick={() => this.toggleShowing("chart")}
                    className={classes.cardTextView}
                  >
                    Click to view
                  </p>
                </Link>
              );
            }
          });
        } else if (
          count === 4 &&
          item.index === 4 &&
          item.category !== "Text"
        ) {
          name = dummyTitle;
        }

        if (count === 5 && item.index === 5 && item.category === "Media") {
          item.sections.widget_contents.map((s) => {
            imageChart = (
              <Card.Img className={classes.image_zoom} src={s.file} />
            );
            return <>{imageChart}</>;
          });
        }

        if (count === 6 && item.index === 6 && item.category === "Article") {
          item.sections.widget_contents.forEach((s) => {
            contentLetter = (
              <Letter
                isData={true}
                title={titleSection}
                data={s}
                onClick={this.toggleHiding}
                onStyle={"in"}
              />
            );
          });
        } else if (
          count === 6 &&
          item.index === 6 &&
          item.category !== "Article"
        ) {
          contentLetter = (
            <Letter
              isData={false}
              title={titleSection}
              data={null}
              onClick={this.toggleHiding}
              onStyle={"in"}
            />
          );
        }

        if (count === 7 && item.index === 7 && item.category === "Article") {
          articleBoxes = item.sections.widget_contents.map((article, index) => {
            const clickText = this.state.sections[5].sections.widget_contents;

            return (
              <div className={classes.box_1}>
                <div className={classes.box_hover}>
                  <img
                    className={classes.img_box}
                    src={
                      article.assets.length > 0
                        ? article.assets[0].file
                        : require("../assets/1.jpg")
                    }
                    alt=" "
                  />
                  <div
                    className={[classes._overlay, classes._absolute].join(" ")}
                  ></div>
                  <div className={classes._absolute}>
                    <div className={classes._content}>
                      <div className={classes._box}>
                        <p className={classes.customUnderline}>
                          {article.title}{" "}
                        </p>
                        <div className={classes.contentBottomTitle}>
                          <div className={classes.outerCircle2}>
                            <div className={classes.innerCircle2}></div>
                          </div>

                          <span className={classes.readMore2}>
                            <a href={article.url}>{readText}</a>
                          </span>
                        </div>
                        {/* <div className={classes.contentBottomTitle}>
                          <div className={classes.outerCircleBot}>
                            <div className={classes.innerCircleBot}></div>
                          </div>
                          <span>
                            <a href={article.url}>
                              {clickText[index]
                                ? clickText[index].content
                                : "Click More"}
                            </a>
                          </span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          });
        }
      });
    } else if (this.state.isApiLoaded) {
      dummy.forEach((s) => {
        if (s.id === 1) {
          images = (
            <img className={classes.img_first_2} src={s.assets} alt="" />
          );
        } else if (s.id === 2) {
          contentArticle = s.articles.map((s) => {
            let isImage = s.assets[0] ? (
              <img className={classes.image} src={s.assets[0].file} alt="" />
            ) : (
              <img
                className={classes.imageDefault}
                src={require("../assets/default-image.svg")}
                alt=""
              />
            );

            return (
              <div className={classes.col_second}>
                <h4>{s.title}</h4>
                <br />
                <p>{ReactHtmlParser(s.content)}</p>
                <br />
                <p className={classes.readMore} onClick={this.toggleShowing}>
                  Read more
                </p>
              </div>
            );
          });
        } else if (s.id === 3) {
          name = <p className={classes.card_text_row_1_col_2}>{s.content}</p>;
        } else if (s.id === 4) {
          imageChart = (
            <Card.Img className={classes.image_zoom} src={s.assets} />
          );
        }
      });
    }

    return (
      <>
        <Row>
          <div className={classes.backgroundRowFirst}>
            <div
              className={[
                "container",
                classes.row_first,
                classes.customContainer,
              ].join(" ")}
            >
              <div className={classes.Circuit}>
                <Circuit />
              </div>
              <div className={classes._flexDir}>
                {/* <div className={classes.col_second}>{titleP}</div> */}
                <div className={classes.boxPhoto}>{images}</div>
                <div className={classes._boxB}>{contentArticle}</div>
              </div>

              {/* <div className={classes.col_first}>{images}</div>
                {contentArticle} */}

              <Modal
                dialogClassName={classes.modalFull}
                show={this.state.detailLoaded}
                onHide={this.toggleHiding}
              >
                <Modal.Header
                  className={classes.modalHeader}
                  onClick={this.toggleHiding}
                  closeButton
                />
                <div className={classes.boxModal}>{contentLetter}</div>
              </Modal>
            </div>
          </div>
        </Row>
        <Row className={classes.Row_2}>
          <div
            className={[
              "container",
              classes.box_c,
              classes.customContainer,
            ].join(" ")}
          >
            <div className="d-flex justify-content-between">{articleBoxes}</div>
          </div>
        </Row>
      </>
    );
  }
}

export default teams;
